import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseNewVersionSearch } from "@/features/content";
import { NewLegalVersionPage } from "@/features/content/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/growth/legal/new")({
  validateSearch: strictSearch(parseNewVersionSearch),
  component: NewVersion,
});

function NewVersion() {
  const { from } = Route.useSearch();
  const router = useRouter();
  return (
    <NewLegalVersionPage
      key={from ?? "new"}
      from={from}
      onCreated={(versionId) =>
        void router.navigate({
          to: "/growth/legal/$versionId",
          params: { versionId },
          replace: true,
        })
      }
      onCancel={() => void router.navigate({ to: "/growth/legal" })}
    />
  );
}
